var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.48 92.733H19.313a1 1 0 0 1-.999-.952l-2-41.5-.001-30.829a1 1 0 0 1 1-1h8.604a1 1 0 0 1 0 2h-7.604v29.781l1.953 40.5h34.26l1.954-40.548V20.452h-8.125a1 1 0 0 1 0-2h9.125a1 1 0 0 1 1 1v30.781l-2.001 41.548a1 1 0 0 1-.999.952z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.23 52.235H21.564a1 1 0 0 1-1-1V30.562a1 1 0 0 1 1-1H53.23a1 1 0 0 1 1 1v20.673a1 1 0 0 1-1 1zm-30.666-2H52.23V31.562H22.564zM29.852 66.392h-4.909a1 1 0 0 1-1-1v-4.909a1 1 0 0 1 1-1h4.909a1 1 0 0 1 1 1v4.909a1 1 0 0 1-1 1zm-3.91-2h2.909v-2.909h-2.909zM39.852 66.392h-4.909a1 1 0 0 1-1-1v-4.909a1 1 0 0 1 1-1h4.909a1 1 0 0 1 1 1v4.909a1 1 0 0 1-1 1zm-3.91-2h2.909v-2.909h-2.909zM49.852 66.392h-4.909a1 1 0 0 1-1-1v-4.909a1 1 0 0 1 1-1h4.909a1 1 0 0 1 1 1v4.909a1 1 0 0 1-1 1zm-3.91-2h2.909v-2.909h-2.909zM29.852 76.392h-4.909a1 1 0 0 1-1-1v-4.909a1 1 0 0 1 1-1h4.909a1 1 0 0 1 1 1v4.909a1 1 0 0 1-1 1zm-3.91-2h2.909v-2.909h-2.909zM39.852 76.392h-4.909a1 1 0 0 1-1-1v-4.909a1 1 0 0 1 1-1h4.909a1 1 0 0 1 1 1v4.909a1 1 0 0 1-1 1zm-3.91-2h2.909v-2.909h-2.909zM49.852 76.392h-4.909a1 1 0 0 1-1-1v-4.909a1 1 0 0 1 1-1h4.909a1 1 0 0 1 1 1v4.909a1 1 0 0 1-1 1zm-3.91-2h2.909v-2.909h-2.909zM29.852 86.392h-4.909a1 1 0 0 1-1-1v-4.909a1 1 0 0 1 1-1h4.909a1 1 0 0 1 1 1v4.909a1 1 0 0 1-1 1zm-3.91-2h2.909v-2.909h-2.909zM39.852 86.392h-4.909a1 1 0 0 1-1-1v-4.909a1 1 0 0 1 1-1h4.909a1 1 0 0 1 1 1v4.909a1 1 0 0 1-1 1zm-3.91-2h2.909v-2.909h-2.909zM49.852 86.392h-4.909a1 1 0 0 1-1-1v-4.909a1 1 0 0 1 1-1h4.909a1 1 0 0 1 1 1v4.909a1 1 0 0 1-1 1zm-3.91-2h2.909v-2.909h-2.909zM51.129 26.608H23.693a1 1 0 0 1 0-2h27.436a1 1 0 0 1 0 2z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.335 26.608H26.459a1 1 0 0 1-1-1V10.233a1 1 0 0 1 1-1h21.876a1 1 0 0 1 1 1v15.375a1 1 0 0 1-1 1zm-20.876-2h19.876V11.233H27.459zM77.946 17.062a.997.997 0 0 1-.741-.328c-1.445-1.592-2.969-2.369-4.452-2.335-2.445.068-4.258 2.269-4.276 2.291a1 1 0 0 1-1.559-1.252c.096-.12 2.387-2.933 5.76-3.037 2.134-.058 4.147.94 6.007 2.989a1 1 0 0 1-.739 1.672z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.687 14.397a.997.997 0 0 1-.741-.328c-2.977-3.278-6.108-4.902-9.296-4.799-5.143.151-8.875 4.707-8.912 4.753a.998.998 0 0 1-1.405.152.998.998 0 0 1-.154-1.404c.173-.217 4.324-5.313 10.396-5.5 3.825-.101 7.461 1.717 10.853 5.453a1 1 0 0 1-.741 1.673zM72.823 22.573c-1.529 0-2.773-1.244-2.773-2.773s1.244-2.773 2.773-2.773 2.773 1.244 2.773 2.773-1.244 2.773-2.773 2.773zm0-3.546a.774.774 0 0 0 0 1.546.774.774 0 0 0 0-1.546z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosIcon);
export default __webpack_public_path__ + "static/media/pos-icon.cd5a2207fb2950f0d097042b95e0b05b.svg";
export { ForwardRef as ReactComponent };